export const style = {
    iframe: {border: 0, marginTop: '25px', marginBottom: '8px'},
    title: {my: 2, fontSize: 20, fontWeight: 600},
    locationTypo: {my: 2, fontSize: 15},
    textTimeAndDate: { width: "100%", textAlign: "center", my: 2 },
    button: {
        borderRadius: '20px',
        backgroundColor: 'rgb(180, 199, 74)',
        color: 'white',
        border: 'rgb(180, 199, 74)',
    },
    button2: {
        width: '100%',
        borderRadius: '20px',
        backgroundColor: 'rgb(180, 199, 74)',
        color: 'white',
        border: 'rgb(180, 199, 74)',
    },
    icon: {marginRight: '10px'},
    textField: {marginTop: 3, width: "100%"}
}
